import { Outlet, Navigate } from 'react-router-dom';

export default function AuthenticatedProtectedRoutes ({ isAuthenticated }) {    
    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }
    return <Outlet />;    
}

